/* MT rail (2026-10-10): one-row horizontal scrollers with edge fades + prev/next arrows.
   Used by the collection header shortcut pills (.mt-ch__pills) and the Boost desktop
   filter bar (.mt-dgrid-topbar .boost-pfs-filter-tree-h). Desktop (>=768px) only: mobile
   already swipes and keeps its own treatment.

   Edges are absolutely positioned siblings inside the host, laid over the scroller's
   left/right ends from measured geometry, so they never change layout. Boost wipes the
   tree's innerHTML on every render: everything added lives OUTSIDE the tree, and a
   MutationObserver re-syncs.

   Boost dropdowns (.boost-pfs-filter-option-content) are absolutely positioned inside
   the now-scrolling tree and would be clipped by it, so an open one is lifted to
   position:fixed under its pill (clamped to the viewport) and kept there on page scroll,
   rail scroll and resize. Boost's own open/close, click-outside, Escape and instant apply
   are untouched. */
(function () {
  'use strict';
  if (window.MTRail) { window.MTRail.scan(); return; }
  var DESK = window.matchMedia('(min-width: 768px)');
  var rails = [];

  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mt-rail-btn';
    b.tabIndex = -1;
    b.setAttribute('aria-label', dir < 0 ? 'Scroll left' : 'Scroll right');
    b.innerHTML = dir < 0
      ? '<svg viewBox="0 0 10 16" width="8" height="13" aria-hidden="true"><path d="M8 2 2 8l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 10 16" width="8" height="13" aria-hidden="true"><path d="m2 2 6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function Rail(scroller, host) {
    var self = this;
    this.s = scroller;
    this.h = host;
    host.classList.add('mt-rail-host');
    scroller.classList.add('mt-rail-track');
    this.start = document.createElement('div');
    this.start.className = 'mt-rail-edge mt-rail-edge--start';
    this.end = document.createElement('div');
    this.end.className = 'mt-rail-edge mt-rail-edge--end';
    var prev = arrow(-1), next = arrow(1);
    this.start.appendChild(prev);
    this.end.appendChild(next);
    host.appendChild(this.start);
    host.appendChild(this.end);
    prev.addEventListener('click', function () { self.by(-1); });
    next.addEventListener('click', function () { self.by(1); });
    var queued = false;
    this.queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; self.sync(); });
    };
    scroller.addEventListener('scroll', this.queue, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(this.queue);
      ro.observe(scroller);
      ro.observe(host);
    }
    new MutationObserver(this.queue).observe(scroller, { childList: true, subtree: true });
    this.sync();
  }
  Rail.prototype.by = function (dir) {
    var s = this.s;
    var step = Math.max(160, Math.round(s.clientWidth * 0.7));
    try { s.scrollBy({ left: dir * step, behavior: 'smooth' }); } catch (e) { s.scrollLeft += dir * step; }
  };
  Rail.prototype.sync = function () {
    var s = this.s, on = DESK.matches && s.isConnected;
    var over = on && s.scrollWidth > s.clientWidth + 2;
    var atStart = s.scrollLeft <= 2;
    var atEnd = s.scrollLeft + s.clientWidth >= s.scrollWidth - 2;
    if (on) {
      var hr = this.h.getBoundingClientRect(), sr = s.getBoundingClientRect();
      var top = Math.round(sr.top - hr.top) + 'px', height = Math.round(sr.height) + 'px';
      this.start.style.top = top; this.start.style.height = height;
      this.start.style.left = Math.round(sr.left - hr.left) + 'px';
      this.end.style.top = top; this.end.style.height = height;
      this.end.style.left = Math.round(sr.right - hr.left - this.end.offsetWidth) + 'px';
    }
    this.start.classList.toggle('is-on', !!(over && !atStart));
    this.end.classList.toggle('is-on', !!(over && !atEnd));
    this.h.classList.toggle('mt-rail-overflow', !!over);
  };

  function attach(scroller, host) {
    if (!scroller || !host || scroller.__mtRail) return;
    scroller.__mtRail = new Rail(scroller, host);
    rails.push(scroller.__mtRail);
  }

  /* ---------- Boost dropdowns: lift the open panel out of the scroller ---------- */
  var openPanels = [];
  function placePanels() {
    openPanels = openPanels.filter(function (c) { return c.isConnected && getComputedStyle(c).display !== 'none'; });
    openPanels.forEach(function (c) {
      var opt = c.closest('.boost-pfs-filter-option');
      var head = opt && opt.querySelector('.boost-pfs-filter-option-title-heading');
      if (!head) return;
      var r = head.getBoundingClientRect();
      c.style.position = 'fixed';
      c.style.right = 'auto';
      c.style.bottom = 'auto';
      c.style.zIndex = '60';
      c.style.top = Math.round(r.bottom) + 'px'; /* CSS adds the 8px gap (margin-top) */
      var w = c.offsetWidth;
      var left = Math.min(r.left, window.innerWidth - w - 12);
      c.style.left = Math.round(Math.max(12, left)) + 'px';
    });
  }
  var placeQueued = false;
  function queuePlace() {
    if (placeQueued || !openPanels.length) return;
    placeQueued = true;
    requestAnimationFrame(function () { placeQueued = false; placePanels(); });
  }
  function watchBoostPanels(tree) {
    function scan() {
      if (!DESK.matches) return;
      tree.querySelectorAll('.boost-pfs-filter-option-content').forEach(function (c) {
        if (getComputedStyle(c).display !== 'none' && openPanels.indexOf(c) < 0) openPanels.push(c);
      });
      placePanels();
    }
    /* synchronous with Boost's style/class flip, so the panel is lifted before paint */
    new MutationObserver(scan).observe(tree, {
      attributes: true, attributeFilter: ['style', 'class', 'aria-expanded'], childList: true, subtree: true
    });
    tree.addEventListener('scroll', queuePlace, { passive: true });
  }
  window.addEventListener('scroll', queuePlace, { passive: true });
  window.addEventListener('resize', function () { queuePlace(); rails.forEach(function (r) { r.queue(); }); });

  function scan() {
    document.querySelectorAll('.mt-ch__pills').forEach(function (nav) {
      attach(nav, nav.closest('.mt-ch__wrap') || nav.parentElement);
    });
    var bar = document.querySelector('.mt-dgrid-topbar');
    if (bar) {
      var tree = bar.querySelector('.boost-pfs-filter-tree-h');
      var host = tree && tree.parentElement;
      if (tree && !tree.__mtRail) {
        attach(tree, host);
        watchBoostPanels(tree);
      }
    }
  }
  if (DESK.addEventListener) DESK.addEventListener('change', function () { rails.forEach(function (r) { r.queue(); }); });
  window.MTRail = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', function () { scan(); rails.forEach(function (r) { r.queue(); }); });
})();
